import api, { ResponsePayloadWithData } from '../../../../api';

export interface TeacherMaterialCount {
  userMaterial: number;
  userSlideSets: number;
  slideSets: number;
}

export interface StudentMaterialCount {
  sharedMaterial: number;
  sharedSlideSets: number;
  slideSets: number;
}

export const getTeacherMaterialCount = async (moduleId: string) => {
  const { data } = await api.get<ResponsePayloadWithData<TeacherMaterialCount>>(
    `/studio/user/modules/${moduleId}/material/teacher/count`,
  );

  return data.data;
};

export const getStudentMaterialCount = async (moduleId: string) => {
  const { data } = await api.get<ResponsePayloadWithData<StudentMaterialCount>>(
    `/studio/user/modules/${moduleId}/material/student/count`,
  );

  return data.data;
};
